import { Link as PortalsLink } from '@portals/core/src/components/Link/Link';
import { ArrowRight } from '@portals/icons/src/ArrowRight/ArrowRight';
import { File } from '@portals/icons/src/File/File';
import { Mail } from '@portals/icons/src/Mail/Mail';
import { Telephone } from '@portals/icons/src/Telephone/Telephone';
import React, { PropsWithChildren } from 'react';

import { isLinkAssetLink, isLinkExternalLink } from '../../../models';
import { Link as LinkModel, useLinkProps } from '../../hooks/useLinkProps';
interface Props {
  link: LinkModel;
}

export const Link: React.FC<PropsWithChildren<Props>> = ({ link, children }) => {
  const { singleProps } = useLinkProps(link);

  // Note: Abweichend zum Model sind für RichTextLinks der Title im Feld "text" abgespeichert
  const title = singleProps?.title || (link.text !== children && link.text ? link.text : undefined);

  if (isLinkAssetLink(link)) {
    return (
      <PortalsLink {...singleProps} title={title}>
        {children}
        &nbsp;
        <File />
      </PortalsLink>
    );
  }

  if (isLinkExternalLink(link) && singleProps?.href?.startsWith('tel://')) {
    return (
      <PortalsLink {...singleProps} title={title}>
        {children}
        &nbsp;
        <Telephone />
      </PortalsLink>
    );
  }

  if (isLinkExternalLink(link) && singleProps?.href?.startsWith('mailto://')) {
    return (
      <PortalsLink {...singleProps} title={title}>
        {children}
        &nbsp;
        <Mail />
      </PortalsLink>
    );
  }

  if (isLinkExternalLink(link)) {
    return (
      <PortalsLink {...singleProps} title={title}>
        {children}
        &nbsp;
        <ArrowRight />
      </PortalsLink>
    );
  }

  return (
    <PortalsLink {...singleProps} title={title}>
      {children}
    </PortalsLink>
  );
};
